<template>
    <div class="w-100" style="padding: 2% 3%">
        <div class="d-block w-100" ref="fadeWhenModelOpen">
                <ul class="tags-display-ul p-0 w-100 m-0">
                    <div style="display: grid;">
                        <li style="display:inline-flex">
                            <table class="table-scroll" style="background: transparent; width: 91%">
                                <thead>
                                    <tr>
                                        <th scope="col" style="width: 25%" class="text-left col-md-3">
                                        </th>
                                        <th scope="col" style="width: 70%" class="text-center col-md-6">
                                        </th>
                                        <th scope="col" style="width: 5%" class="text-right col-md-1"></th>
                                    </tr>
                                </thead>
                                <tbody class="body-half-screen">
                                    <template v-for="key in selectedFieldsInfo">
                                        <tr v-if="(isFieldType(key.row_type) && isFieldExists(key.field_id)) || !isFieldType(key.row_type)" :key="key.row_type" class="comm-table-row">
                                            <td class="comm-field-wrapper">
                                                <Multiselect
                                                    v-model="labelOfLoadTypes[key.uuid]"
                                                    :options="filteredLoadTypes"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :allow-empty="false"
                                                    @select="updateRowType($event,key)"
                                                    label="label"
                                                    deselectLabel=""
                                                    selectLabel=""
                                                    selectedLabel=""
                                                    track-by="field_id">
                                                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                        <span style="margin-inline-start:12px;">
                                                            {{ scope.option.label }}
                                                        </span>
                                                    </div>
                                                </Multiselect>
                                            </td>
                                            <td class="comm-field-wrapper">
                                                <div v-if="key.row_type =='DESCRIPTION'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode">
                                                        <span v-if="key.value != undefined && key.value.length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else>{{key.value}}</span>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="desctypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <textarea
                                                            v-if="key.action != 'Clear'"
                                                            id="field_value"
                                                            class="rounded text-light comm-input-field-style"
                                                            v-model="key.value"
                                                            autocomplete="off"
                                                            placeholder="ex: Olympics"
                                                            style="height: 100px;position: relative;bottom: 2px;top:5px;margin-bottom:5px;width:50% !important"
                                                        >
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div v-else-if="['TAG'].includes(key.row_type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                                                        <span v-if="selectedTagIdList[key.field_id] != undefined && selectedTagIdList[key.field_id].length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <div v-else v-for="picklist in selectedTagIdList[key.field_id]" :key="picklist._id" class="tags-style">
                                                            <div class="user-name-display user-name-display-as-tags">{{picklist.label}}</div>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">  
                                                        <Multiselect
                                                            v-model="key.action"
                                                            :options="tagTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <template v-if="key.action == 'Find and replace' && key.action != 'Clear'">
                                                            <tags-dropdown ref="findTag" :componentUUID="key.uuid" @updatedBulkTagsList="tagsFindCollectionOnMultiSelect" @updatedTagsList="tagsFindCollectionOnSelect" @removedTagsFromList="tagsFindCollectionOnRemove" style="width: 50% !important;"></tags-dropdown>
                                                            <span style="margin:12px 11px;color: #939393;"> with </span>
                                                        </template>
                                                        <tags-dropdown ref="tagValues" v-if="key.action != 'Clear'" :componentUUID="key.uuid" @updatedBulkTagsList="tagsCollectionOnMultiSelect" @updatedTagsList="tagsCollectionOnSelect" @removedTagsFromList="tagsCollectionOnRemove" style="width: 50% !important;"></tags-dropdown>
                                                    </div>
                                                </div>
                                                <div v-else-if="['CATALOG'].includes(key.row_type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                                                        <span v-if="selectedTagIdList[key.field_id] != undefined && selectedTagIdList[key.field_id].length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <div v-else v-for="picklist in selectedTagIdList[key.field_id]" :key="picklist._id" class="tags-style">
                                                            <div class="user-name-display user-name-display-as-tags">{{picklist.label}}</div>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="catalogTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <template v-if="key.action == 'Find and replace' && key.action != 'Clear'">
                                                            <multi-catalog-dropdown ref="findTag" :enableCatBrowser='true' :componentUUID="key.uuid +'-find'" style="width:50%;margin-inline-start:5px;"
                                                                @updatedCatalogsList="updatedFindCatalogsListComp" @removedCatalogFromList="removedFindCatalogFromListComp"
                                                                :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                                                :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                                                from="TagMetadata"
                                                                >
                                                            </multi-catalog-dropdown>
                                                            <span style="margin:12px 11px;color: #939393;"> with </span>
                                                        </template>
                                                        <multi-catalog-dropdown ref="tagValues" v-if="key.action != 'Clear'" :enableCatBrowser='true' :componentUUID="key.uuid" style="width:50%;margin-inline-start:5px;"
                                                            @updatedCatalogsList="updatedCatalogsListComp" @removedCatalogFromList="removedCatalogFromListComp"
                                                            :allowSingleSelect="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                                            :allowSingleSelectFromBrowse="!(globalSettingsFromStartup && globalSettingsFromStartup.enable_multi_catalog_browse)"
                                                            from="TagMetadata"
                                                            >
                                                        </multi-catalog-dropdown>
                                                    </div>
                                                </div>
                                                <div v-if="key.row_type =='FREETEXT'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode">
                                                        <span v-if="key.value != undefined && key.value.length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else>{{key.value}}</span>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="textTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <input
                                                            v-if="key.action != 'Clear'"
                                                            type="text"
                                                            id="field_value"
                                                            class="rounded text-light comm-input-field-style"
                                                            v-model="key.value"
                                                            autocomplete="off"
                                                            placeholder="ex: Olympics"
                                                            style="height: 42px;position: relative;bottom: 2px;top:5px;width:50% !important"
                                                        />
                                                    </div>
                                                </div>
                                                <div v-if="key.row_type == 'FREETEXT_MULTILINE'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode">
                                                        <span v-if="key.value.length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else style="text-align:start;line-height:normal">{{key.value}}</span>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="textTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <textarea
                                                            v-if="key.action != 'Clear'"
                                                            id="field_value"
                                                            class="rounded text-light comm-input-field-style"
                                                            v-model="key.value"
                                                            autocomplete="off"
                                                            placeholder="ex: Olympics"
                                                            style="height: 100px;position: relative;bottom: 2px;top:5px;margin-bottom:5px;width:50% !important"
                                                        >
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div v-if="key.row_type == 'DATE'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode">
                                                        <span v-if="Object.keys(key.value).length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else style="text-align:start">{{key.value[0] + ' ~ ' + key.value[1]}}</span>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="dateTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <date-picker
                                                            :editable="false"
                                                            v-if="key.action != 'Clear'"
                                                            v-model="key.value"
                                                            valueType="format"
                                                            placeholder="ex: yyyy-mm-dd"
                                                            class="text-light comm-input-field-style"
                                                            style="padding: 0px;border-radius: 5px;position:relative;top:6px;width:50% !important"
                                                            :id="key.uuid"
                                                            >
                                                        </date-picker>
                                                    </div>
                                                </div>
                                                <div v-if="key.row_type == 'DATE_TIME'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode">
                                                        <span v-if="Object.keys(key.value).length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else style="text-align:start">{{key.value[0] + ' ~ ' + key.value[1]}}</span>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="dateTimeTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            valueType="format"
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <date-picker
                                                            :editable="false"
                                                            v-if="key.action != 'Clear'"
                                                            v-model="key.value"
                                                            placeholder="ex: yyyy-mm-dd"
                                                            class="text-light comm-input-field-style"
                                                            style="padding: 0px;border-radius: 5px;position:relative;top:6px;width:50% !important"
                                                            :id="key.uuid"
                                                            type="datetime"
                                                            valueType="format"
                                                            confirm
                                                            >
                                                        </date-picker>
                                                    </div>
                                                </div>
                                                <div v-if="key.row_type == 'INTEGER'" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode">
                                                        <span v-if="key.value == undefined || (key.value != undefined && key.value.length == 0)"  class="empty-field-text-styles">NONE</span>
                                                        <span v-else>{{key.value['from'] + "  to  " + key.value['to']}}</span>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="integerTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <input
                                                            v-if="key.action != 'Clear'"
                                                            type="number"
                                                            id="date_value"
                                                            style="width:50% !important;position:relative;top:6px"
                                                            class="rounded text-light comm-input-field-style"
                                                            placeholder="ex: 0"
                                                            v-model.number="key.value"
                                                            autocomplete="off"
                                                        />
                                                    </div>
                                                </div>
                                                <div v-if="['PICKLIST'].includes(key.row_type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                                                        <span v-if="selectedPickListNameValues[key.field_id] != undefined && selectedPickListNameValues[key.field_id].length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <div v-else v-for="picklist in selectedPickListNameValues[key.field_id]" :key="picklist._id" class="tags-style">
                                                            <div class="user-name-display user-name-display-as-tags">{{picklist.label}}</div>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">  
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="picklistTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <template v-if="key.action == 'Find and replace' && key.action != 'Clear'">
                                                            <Multiselect
                                                                v-model="selectedFindPickValue[key.uuid]"
                                                                v-if="key.action != 'Clear'"
                                                                :options="findPickListNameCollection.filter(i=>i.field_id==key.field_id)"
                                                                :multiple="false"
                                                                track-by="_id"
                                                                label="label"
                                                                :custom-label="picklistTypeValueCallback"
                                                                :close-on-select="true"
                                                                :show-no-results="false"
                                                                deselectLabel =""
                                                                selectLabel=""
                                                                selectedLabel=""
                                                                placeholder="Enter picklist name"
                                                                :hideSelected="false"
                                                                :showNoOptions="false"
                                                                @select="changeFindPicklistValue($event,key.uuid)"
                                                                style="width:50% !important"
                                                                >
                                                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                    <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                                                                </div>
                                                                <span slot="noResult">No results</span>
                                                                <span slot="noOptions" style="display:none"></span>
                                                            </Multiselect>
                                                            <span style="margin:12px 11px;color: #939393;"> with </span>
                                                        </template>
                                                        <Multiselect
                                                            v-model="selectedPickValue[key.uuid]"
                                                            v-if="key.action != 'Clear'"
                                                            :options="pickListNameCollection.filter(i=>i.field_id==key.field_id)"
                                                            :multiple="false"
                                                            track-by="_id"
                                                            label="label"
                                                            :custom-label="picklistTypeValueCallback"
                                                            :close-on-select="true"
                                                            :show-no-results="false"
                                                            deselectLabel =""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            placeholder="Enter picklist name"
                                                            :hideSelected="false"
                                                            :showNoOptions="false"
                                                            @select="changePicklistValue($event,key.uuid)"
                                                            style="width:50% !important"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                                                            </div>
                                                            <span slot="noResult">No results</span>
                                                            <span slot="noOptions" style="display:none"></span>
                                                        </Multiselect>
                                                    </div>
                                                </div>
                                                <div v-if="['PICKLIST_MULTIVALUE'].includes(key.row_type)" class="comm-screen-profile-fields" style="display: flex;width:100%;position:relative">
                                                    <div v-if="!newProfile" class="fields-on-non-edit-mode"  style="margin-top:11px;">
                                                        <span v-if="selectedPickListNameValues[key.field_id] != undefined && selectedPickListNameValues[key.field_id].length == 0"  class="empty-field-text-styles">NONE</span>
                                                        <div v-else v-for="picklist in selectedPickListNameValues[key.field_id]" :key="picklist._id" class="tags-style">
                                                            <div class="user-name-display user-name-display-as-tags">{{picklist.label}}</div>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="newProfile" class="input-field-wrapper">  
                                                         <Multiselect
                                                            v-model="key.action"
                                                            :options="multiPicklistTypeReq"
                                                            :searchable="true"
                                                            :close-on-select="true"
                                                            :allow-empty="false"
                                                            deselectLabel=""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            class="action-select-dropdown"
                                                            >
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <span style="margin-inline-start:12px;">
                                                                    {{ scope.option }}
                                                                </span>
                                                            </div>
                                                        </Multiselect>
                                                        <template v-if="key.action == 'Find and replace' && key.action != 'Clear'">
                                                            <Multiselect
                                                                v-model="findSelectedPickListNameCollection[key.field_id]" 
                                                                :options="findPickListNameCollection.filter(i=>i.field_id==key.field_id)"
                                                                :multiple="true"
                                                                track-by="_id"
                                                                label="label"
                                                                :custom-label="picklistTypeValueCallback"
                                                                :close-on-select="false"
                                                                :show-no-results="false"
                                                                deselectLabel =""
                                                                selectLabel=""
                                                                selectedLabel=""
                                                                placeholder="Enter picklist name"
                                                                :hideSelected="false"
                                                                :showNoOptions="false"
                                                                style="width:50% !important"
                                                                @select="findPicklistCollectionOnSelect($event, key.field_id, key.uuid)"
                                                                @remove="findPicklistCollectionOnRemove($event, key.field_id,  key.uuid)">
                                                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                    <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="findMakePickValCheckBoxSelection(scope.option,key.field_id)" @focus.prevent :key="scope.option.label"/>
                                                                    <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                                                                </div>
                                                                <span slot="noResult">No results</span>
                                                                <span slot="noOptions" style="display:none"></span>
                                                            </Multiselect>
                                                            <span style="margin:12px 11px;color: #939393;"> with </span>
                                                        </template>
                                                        <Multiselect
                                                            v-if="key.action != 'Clear'"
                                                            v-model="selectedPickListNameCollection[key.field_id]" 
                                                            :options="pickListNameCollection.filter(i=>i.field_id==key.field_id)"
                                                            :multiple="true"
                                                            track-by="_id"
                                                            label="label"
                                                            :custom-label="picklistTypeValueCallback"
                                                            :close-on-select="false"
                                                            :show-no-results="false"
                                                            deselectLabel =""
                                                            selectLabel=""
                                                            selectedLabel=""
                                                            placeholder="Enter picklist name"
                                                            :hideSelected="false"
                                                            :showNoOptions="false"
                                                            style="width:50% !important"
                                                            @select="picklistCollectionOnSelect($event, key.field_id, key.uuid)"
                                                            @remove="picklistCollectionOnRemove($event, key.field_id,  key.uuid)">
                                                            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                                                <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makePickValCheckBoxSelection(scope.option,key.field_id)" @focus.prevent :key="scope.option.label"/>
                                                                <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                                                            </div>
                                                            <span slot="noResult">No results</span>
                                                            <span slot="noOptions" style="display:none"></span>
                                                        </Multiselect>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="comm-field-wrapper delete-icon-wrapper" title="Delete">
                                                <delete-icon class="browse-icon delete-btn" style="height:20px !important;width:20px; !important;"
                                                    v-if="selectedFieldsInfo.length > 1" @click.native="deleteLoadType('loaded_fields', key.uuid,key.label)" title="Remove Field"></delete-icon>
                                            </td>
                                        </tr>
                                    </template>
                                    <div class="add-screens-styles" @click="addSelectedLoadTypePath()">
                                      <div style="margin-inline-end:10px">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                        </svg>
                                      </div>
                                      <div style="font-size: 15px;line-height: 40px;">Add Fields</div>
                                    </div>
                                </tbody>
                            </table>
                        </li>
                    </div>
                </ul>
        </div>
    </div>
</template>


<script>
import {mapGetters, mapMutations} from "vuex";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
import Multiselect from 'vue-multiselect';
import deleteIcon from "../core/InlineDeleteIcon.vue";
import TagDropDownComponent from "../tags/TagsSelectionDropdown.vue";
import CatalogDropdownComponent from "../categories/CatalogMultiselectDropdown.vue";
import {NotifierConstants} from "../../components.constants.js";
import DatePicker from "vue2-datepicker";

export default {
    props:['disableFields'],
    components:{
        "delete-icon":deleteIcon,
        "Multiselect":Multiselect,
        "tags-dropdown":TagDropDownComponent,
        "multi-catalog-dropdown":CatalogDropdownComponent,
        "date-picker":DatePicker,
    },
    data() {
        return {
            findSelectedPickListNameCollection:{},
            selectedPickListNameCollection:{},
            findPickListNameCollection:[],
            pickListNameCollection:[],
            startupFieldsList:[],
            loadTypes:[
                {label:"",row_type:Constants.loadEmpty,'field_id':Constants.loadEmpty},
                {label:"Description",row_type:"DESCRIPTION", 'field_id':'DESCRIPTION'},
                {label:"Catalog",row_type:"CATALOG", 'field_id':'CATALOG'},
                {label:"Tag",row_type:"TAG",'field_id':'TAG'},
            ],
            textTypeReq:["Append","Replace all with","Clear"],
            picklistTypeReq:["Replace all with","Find and remove","Find and replace","Clear"],
            multiPicklistTypeReq:["Append","Replace all with","Find and remove","Find and replace","Clear"],
            dateTypeReq:["Replace all with","Clear"],
            dateTimeTypeReq:["Replace all with","Clear"],
            integerTypeReq:["Replace all with","Clear"],
            desctypeReq:["Append","Replace all with","Clear"],
            tagTypeReq:["Append","Replace all with","Find and remove","Find and replace","Clear"],
            catalogTypeReq:["Replace all with","Find and replace"],
            selectedFieldsInfo:[],
            selectedPickValue:{
            },
            selectedFindPickValue:{
            },
            isNewRow:null,
            newProfile:true,
            selectedLoadwhenFilter:[],
            labelOfLoadTypes:{},
        };
    },
    methods:{
        //Row updates
        updateRowType(newVal,oldVal){
            if(typeof newVal != "undefined" && typeof oldVal != "undefined"){
                let oldValLabel = oldVal.label
                console.log("newValnewVal",newVal)
                let indx = this.selectedFieldsInfo.findIndex(e => e.field_id == newVal.field_id);
                console.log("this.selectedFieldsInfo",this.selectedFieldsInfo)
                // if(['TAG','CATALOG','DESCRIPTION'].includes(newVal.row_type)){
                //     indx = 0;
                // }
                if(this.selectedLoadwhenFilter.includes(newVal.label) && indx >= 0){
                    alert("Already selected");
                    return;
                }
                let isTypeExists = false;
                for(let loadType of this.selectedFieldsInfo){
                    if(loadType.uuid == oldVal.uuid){
                        isTypeExists = true;
                        loadType.row_type = newVal.row_type;
                        loadType.label = newVal.label;
                        this.isNewRow = loadType.uuid;
                        this.labelOfLoadTypes[loadType.uuid] = {"label":newVal.label};
                        if(this.selectedLoadwhenFilter.includes(oldValLabel)){
                        this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(oldValLabel), 1);
                        }
                        this.selectedLoadwhenFilter.push(newVal.label);
                        if(this.isFieldType(newVal.row_type) && Object.keys(newVal).includes("field_id")){
                            loadType.field_id = newVal.field_id;
                            loadType.type = "field"
                            if(["FREETEXT","FREETEXT_MULTILINE","PICKLIST_MULTIVALUE"].includes(newVal.row_type)){
                                loadType.action = "Append"
                                if("PICKLIST_MULTIVALUE" == newVal.row_type){
                                    loadType.value = []
                                }else{
                                    loadType.value=""
                                }
                            }else if(["INTEGER"].includes(newVal.row_type)){
                                loadType.action = "Replace all with"
                                loadType.value = 0
                            }else if(["INTEGER","PICKLIST","DATE","DATE_TIME"].includes(newVal.row_type)){
                                loadType.action = "Replace all with"
                                if("PICKLIST" == newVal.row_type){
                                    loadType.value = []
                                }else{
                                    loadType.value=""
                                }
                            }
                        }else if(["DESCRIPTION"].includes(newVal.row_type)){
                            loadType.action = "Append",
                            loadType.type = "description",
                            loadType.value="",
                            loadType.field_id="DESCRIPTION"
                        }else if(["TAG","CATALOG"].includes(newVal.row_type)){
                            if(newVal.row_type == "TAG"){
                                loadType.type = "tag"
                                loadType.field_id="TAG"
                                loadType.action = "Append";
                            }else{
                                loadType.type = "catalog"
                                loadType.field_id="CATALOG"
                                if(!('enable_multi_catalog_browse' in this.globalSettingsFromStartup) ||
                                 ('enable_multi_catalog_browse' in this.globalSettingsFromStartup &&
                                  this.globalSettingsFromStartup.enable_multi_catalog_browse)){
                                    loadType.action = "Append";
                                }else{
                                    loadType.action = "Replace all with";
                                }
                            }
                            loadType.value_id=[]
                            loadType.find_value_id =[]
                        }
                    }
                }
                if(!isTypeExists){
                    let newUuid = Utils.getUUID();
                    this.labelOfLoadTypes[newUuid] = {"label":newVal.label};
                    let newEntry = {
                        "row_type":newVal.row_type,
                        "uuid":newUuid,
                        "label":newVal.label,
                        "action":""
                    }
                    if(this.isFieldType(newVal.row_type) && Object.keys(newVal).includes("field_id")){
                        newEntry.type="field"
                        if(["FREETEXT","FREETEXT_MULTILINE","PICKLIST_MULTIVALUE"].includes(newVal.row_type)){
                            if("PICKLIST_MULTIVALUE" == newVal.row_type){
                                newEntry.value = []
                            }else{
                                newEntry.value=""
                            }
                            newEntry.action="Append"
                        }else if(["INTEGER"].includes(newVal.row_type)){
                            newEntry.action = "Replace all with"
                            newEntry.value = 0
                        }else if(["INTEGER","PICKLIST","DATE","DATE_TIME"].includes(newVal.row_type)){
                            newEntry.action = "Replace all with"
                            if("PICKLIST" == newVal.row_type){
                                newEntry.value = []
                            }else{
                                newEntry.value=""
                            }
                        }
                        newEntry.field_id = newVal.field_id;
                        newEntry.value = ""
                    }else if(["DESCRIPTION"].includes(newVal.row_type)){
                            newEntry.action = "Append",
                            newEntry.type = "description",
                            newEntry.value=""
                        }else if(["TAG","CATALOG"].includes(newVal.row_type)){
                            if(newVal.row_type == "TAG"){
                                newEntry.type = "tag"
                                newEntry.action = "Append"
                            }else{
                                newEntry.type = "catalog"
                                if(!('enable_multi_catalog_browse' in this.globalSettingsFromStartup) ||
                                 ('enable_multi_catalog_browse' in this.globalSettingsFromStartup &&
                                  this.globalSettingsFromStartup.enable_multi_catalog_browse)){
                                    newEntry.action = "Append";
                                }else{
                                    newEntry.action = "Replace all with";
                                }
                            }
                            newEntry.value_id=[]
                        }
                    this.selectedLoadwhenFilter.push(newVal.label);
                    this.selectedFieldsInfo.push(newEntry);
                    this.isNewRow = newUuid;
                }
            }
        },
        addSelectedLoadTypePath(){
            let newUuid = Utils.getUUID();
            this.labelOfLoadTypes[newUuid] = "";
            this.selectedFieldsInfo.push({
                "row_type":Constants.loadEmpty,
                "type":"",
                "field_id":"",
                "uuid":newUuid,
                "label":"",
                "action":"",
                "value":""
            })
        },
        deleteLoadType(loadType, loadTypeUuid,label){
            if(typeof loadType == "undefined"){
                return;
            }
            if(loadType == "loaded_fields"){
                if(this.selectedLoadwhenFilter.includes(label)){
                    this.selectedLoadwhenFilter.splice(this.selectedLoadwhenFilter.indexOf(label), 1);
                }
                this.selectedFieldsInfo = this.selectedFieldsInfo.filter(t=>t.uuid !=loadTypeUuid);
            }
        },
        // field type,id verifications
        isFieldType(fieldType){
            return ["FREETEXT","FREETEXT_MULTILINE","DATE","DATE_TIME","INTEGER","PICKLIST","PICKLIST_MULTIVALUE"].includes(fieldType);
        },
        isFieldExists(fieldId){
            let idx = this.startupFieldsList.findIndex(item=>item._id == fieldId);
            if(idx >= 0){
              return true;
            }
            return false;
        },
        //picklist value algorithm
        changePicklistValue(option,FUUID){
            for(let loadType of this.selectedFieldsInfo){
                if(loadType.uuid == FUUID && loadType.field_id == option.field_id){
                    loadType.value = [option._id]
                }
            }
        },
        changeFindPicklistValue(option,FUUID){
            for(let loadType of this.selectedFieldsInfo){
                if(loadType.uuid == FUUID && loadType.field_id == option.field_id){
                    loadType["find_value"] = [option._id]
                }
            }
        },
        picklistTypeValueCallback(option){
          return `${option.label}`
        },
        //picklist Multi values algorithm
        findPicklistCollectionOnSelect(option,FId,FUuid){
            let index = this.findPickListNameCollection.findIndex(item => item._id == option._id && item.field_id == FId);
            if(index > -1){
                this.findPickListNameCollection[index].checked = true;
                
            }
            for(let updateEntry of this.selectedFieldsInfo.filter(op=>op.uuid == FUuid)){
               if('find_value' in updateEntry && updateEntry.find_value){
                    if(!updateEntry.find_value.includes(option._id)){
                        updateEntry.find_value.push(option._id)
                    }
                }else{
                    updateEntry['find_value'] = [option._id]
                }
            }
        },
        findPicklistCollectionOnRemove(option,FId,FUuid){
            let index = this.findPickListNameCollection.findIndex(item => item._id == option._id && item.field_id == FId);
            if(index > -1){
                this.findPickListNameCollection[index].checked = false;
            }
            for(let updateEntry of this.selectedFieldsInfo.filter(op=>op.uuid == FUuid)){
               if('find_value' in updateEntry && updateEntry.find_value && updateEntry.find_value.includes(option._id)){
                    updateEntry.find_value = updateEntry.find_value.filter(op=>op != option._id)
                }
            }
        },
        findMakePickValCheckBoxSelection(option,FId){
            if(Object.keys(this.findSelectedPickListNameCollection).includes(FId)){
                return this.findSelectedPickListNameCollection[FId].some((op) => op._id === option._id);
            }else{
                return false;
            }
        },
        picklistCollectionOnSelect(option,FId, FUuid){
            let index = this.pickListNameCollection.findIndex(item => item._id == option._id && item.field_id == FId);
            if(index > -1){
                this.pickListNameCollection[index].checked = true;
            }
            for(let updateEntry of this.selectedFieldsInfo.filter(op=>op.uuid == FUuid)){
               if('value' in updateEntry && updateEntry.value){
                    if(!updateEntry.value.includes(option._id)){
                        updateEntry.value.push(option._id)
                    }
                }else{
                    updateEntry['value'] = [option._id]
                }
            }
        },
        picklistCollectionOnRemove(option,FId,FUuid){
            let index = this.pickListNameCollection.findIndex(item => item._id == option._id && item.field_id == FId);
            if(index > -1){
                this.pickListNameCollection[index].checked = false;
            }
            for(let updateEntry of this.selectedFieldsInfo.filter(op=>op.uuid == FUuid)){
               if('value' in updateEntry && updateEntry.value && updateEntry.value.includes(option._id)){
                    updateEntry.value = updateEntry.value.filter(op=>op != option._id)
                }
            }
        },
        makePickValCheckBoxSelection(option,FId){
            if(Object.keys(this.selectedPickListNameCollection).includes(FId)){
                return this.selectedPickListNameCollection[FId].some((op) => op._id === option._id);
            }else{
                return false;
            }
        },
        //Tags Algorithm
        tagsCollectionOnMultiSelect(tagIdList, FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    let ids = []
                    if(![undefined, null].includes(tagIdList)){
                        for(let op of tagIdList){
                            ids.push(op)
                        }
                    }
                    updateEntry["value_id"] = ids
                    break;
                }
            }
        },
        tagsCollectionOnSelect(option,FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    if(!Object.keys(updateEntry).includes("value_id") || !updateEntry["value_id"].includes(option._id)){
                        updateEntry["value_id"].push(option._id);
                    }
                    break;
                }
            }
        },
        tagsCollectionOnRemove(option, FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    if(updateEntry["value_id"].includes(option._id)){
                        updateEntry["value_id"] = updateEntry["value_id"].filter(op=>op!=option._id);
                    }
                    break;
                }
            }
        },
        tagsFindCollectionOnMultiSelect(tagIdList, FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    let ids = []
                    if(![undefined, null].includes(tagIdList)){
                        for(let op of tagIdList){
                            ids.push(op)
                        }
                    }
                    updateEntry["find_value_id"] = ids
                    break;
                }
            }
        },
        tagsFindCollectionOnSelect(option,FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    if(!Object.keys(updateEntry).includes("find_value_id") || !updateEntry["find_value_id"].includes(option._id)){
                        updateEntry["find_value_id"].push(option._id);
                    }
                    break;
                }
            }
        },
        tagsFindCollectionOnRemove(option, FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    if(updateEntry["find_value_id"].includes(option._id)){
                        updateEntry["find_value_id"] = updateEntry["find_value_id"].filter(op=>op!=option._id);
                    }
                    break;
                }
            }
        },
        //Catalog Algorithm
        
        updatedCatalogsListComp(option,FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    let newVal = option.parent_id_path + "/" + option._id
                    if(this.globalSettingsFromStartup && this.globalSettingsFromStartup.enable_multi_catalog_browse){
                        if(!updateEntry["value_id"].includes(newVal)){
                            updateEntry["value_id"].push(newVal);
                        }
                    }else{
                        updateEntry["value_id"] = [newVal]
                    }
                    break;
                }
            }
        },
        removedCatalogFromListComp(option,FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid == FUUID){
                    if(updateEntry["value_id"].includes(option.parent_id_path + "/" + option._id)){
                        updateEntry["value_id"] = updateEntry["value_id"].filter(op=>op != (option.parent_id_path + "/" + option._id));
                    }
                    break;
                }
            }
        },
        updatedFindCatalogsListComp(option,FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid+'-find' == FUUID){
                    let newVal = option.parent_id_path + "/" + option._id
                    if(this.globalSettingsFromStartup && this.globalSettingsFromStartup.enable_multi_catalog_browse){
                        if(!updateEntry["find_value_id"].includes(newVal)){
                            updateEntry["find_value_id"].push(newVal);
                        }
                    }else{
                        updateEntry["find_value_id"] = [newVal]
                    }
                    break;
                }
            }
        },
        removedFindCatalogFromListComp(option,FUUID){
            for(let updateEntry of this.selectedFieldsInfo){
                if(updateEntry.uuid+'-find' == FUUID){
                    if(updateEntry["find_value_id"].includes(option.parent_id_path + "/" + option._id)){
                        updateEntry["find_value_id"] = updateEntry["find_value_id"].filter(op=>op != (option.parent_id_path + "/" + option._id));
                    }
                    break;
                }
            }
        },
        updateGlobalSettingsValueFromNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification;
            if(!('enable_multi_catalog_browse' in notification.message) ||
             ('enable_multi_catalog_browse' in notification.message &&
             notification.message.enable_multi_catalog_browse)){
                if(!(this.catalogTypeReq.includes("Append"))){
                    this.catalogTypeReq.unshift("Append")
                }
            }else{
                if(this.catalogTypeReq.includes("Append")){
                    this.catalogTypeReq = this.catalogTypeReq.filter(op=>op != "Append")
                    if(this.selectedFieldsInfo){
                        let catIndx = this.selectedFieldsInfo.findIndex(op=>op.row_type == "CATALOG" && op.action == "Append")
                        if(catIndx >= 0){
                            this.$set(this.selectedFieldsInfo[catIndx], "action", "Replace all with")
                        }
                    }
                }
            }
        },
        //register notifications
        registerWebsocketNotifier(){
            this.addWSEventListener({eventname:[NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.fieldRemovedNotification],
                callback:this.handleFieldsNotification,parent:"BulkMetadataFields"});
            this.addWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"BulkMetadataFields"}); 

        },
        unRegisterWebsocketNotifier(){
            this.removeWSEventListener({eventname:[NotifierConstants.fieldCreatedNotification,NotifierConstants.fieldModifiedNotification,NotifierConstants.fieldRemovedNotification],
                callback:this.handleFieldsNotification,parent:"BulkMetadataFields"});
            this.removeWSEventListener({eventname:NotifierConstants.globalSettingsUpdatedNotification, callback:this.updateGlobalSettingsValueFromNotification, parent:"BulkMetadataFields"}); 
        },
        //handle fields notification
        handleFieldsNotification(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            if(notification.message){
                if([NotifierConstants.fieldCreatedNotification,
                    NotifierConstants.fieldModifiedNotification,
                    NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
                    let entry_info = notification.message;
                    if(NotifierConstants.fileRemovedNotification == notification.message_type){
                        this.loadTypes = this.loadTypes.filter(item=>item.field_id != entry_info.custom_metadata_id);
                        let SFIndex = this.selectedFieldsInfo.findIndex(i=>i.field_id == entry_info.custom_metadata_id);
                        if(SFIndex >= 0){
                            this.selectedFieldsInfo.splice(SFIndex,1);
                        }
                    }
                    setTimeout(()=>{
                        if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
                            let latestFieldList = this.getStartUpDataFromInCache()["custom_metadatas"];
                            let newFieldEntry = latestFieldList.filter(i=>i._id == entry_info.custom_metadata_id);
                            if(newFieldEntry.length > 0){
                                if(NotifierConstants.fieldCreatedNotification == notification.message_type){
                                    this.loadTypes.push({
                                        "label":newFieldEntry[0].name,
                                        "row_type":newFieldEntry[0].type,
                                        "field_id":newFieldEntry[0]._id
                                    })
                                    if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(newFieldEntry[0].type)){
                                        for(let pickVal of newFieldEntry[0].values){
                                            this.pickListNameCollection.push({
                                                "_id":pickVal.value_id,
                                                "label":pickVal.value,
                                                "field_id":newFieldEntry[0]._id
                                            })
                                            this.findPickListNameCollection.push({
                                                "_id":pickVal.value_id,
                                                "label":pickVal.value,
                                                "field_id":newFieldEntry[0]._id
                                            })
                                        }
                                    }
                                }else if(NotifierConstants.fieldModifiedNotification == notification.message_type){
                                    for(let existingField of this.loadTypes){
                                        if(existingField.field_id == newFieldEntry[0]._id){
                                            existingField.label = newFieldEntry[0].name;
                                            if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(existingField.row_type)){
                                                this.pickListNameCollection = this.pickListNameCollection.filter(i=>i.field_id != newFieldEntry[0]._id)
                                                for(let pickVal of newFieldEntry[0].values){
                                                    this.pickListNameCollection.push({
                                                        "_id":pickVal.value_id,
                                                        "label":pickVal.value,
                                                        "field_id":newFieldEntry[0]._id
                                                    })
                                                    this.findPickListNameCollection.push({
                                                        "_id":pickVal.value_id,
                                                        "label":pickVal.value,
                                                        "field_id":newFieldEntry[0]._id
                                                    })
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }, 100);
                }
            }
        },
        getSelectedFieldsData(postData){
            let emptyValRows = [];
            for(let entry of this.selectedFieldsInfo){
                if(entry["type"].trim() == ''){
                    continue;
                }
                let eachRow = {};
                eachRow["type"] = entry["type"];
                eachRow["action"] = entry["action"];
                if(["FREETEXT","FREETEXT_MULTILINE","INTEGER","DATE","DATE_TIME","DESCRIPTION"].includes(entry.row_type)){
                    if(entry.row_type != "DESCRIPTION"){
                        eachRow["field_id"] = entry["field_id"];
                    }
                    if(entry.action != 'Clear'){
                        let eVal = entry["value"];
                        if(entry.row_type == "DATE_TIME"){
                            eVal = eVal.replace(" ","T");
                        }
                        eachRow["value"] = eVal;
                        if(([undefined, null].includes(entry["value"]) ||
                            (["FREETEXT","FREETEXT_MULTILINE","DATE","DATE_TIME","DESCRIPTION"].includes(entry.row_type) && entry["value"].trim().length <= 0)) &&
                         !emptyValRows.includes(entry.label)){
                            emptyValRows.push(entry.label);
                        }
                    }
                }else if(["PICKLIST_MULTIVALUE","PICKLIST"].includes(entry.row_type)){
                    eachRow["field_id"] = entry["field_id"];
                    if(["Find and replace"].includes(entry.action)){
                        eachRow["find_value"] = entry["find_value"];
                        eachRow["replace_value"] = entry["value"];
                        if(([undefined, null].includes(entry["find_value"]) || entry.find_value.length <= 0) && !emptyValRows.includes(entry.label)){
                            emptyValRows.push(entry.label);
                        }
                    }else if(entry.action != 'Clear'){
                        eachRow["value"] = entry["value"]
                        if(([undefined, null].includes(entry["value"]) || entry.value.length <= 0) && !emptyValRows.includes(entry.label)){
                            emptyValRows.push(entry.label);
                        }
                    }
                }else if(["TAG","CATALOG"].includes(entry.row_type)){
                    if(["Find and replace"].includes(entry.action)){
                        eachRow["find_value_id"] = entry["find_value_id"];
                        eachRow["replace_value_id"] = entry["value_id"];
                        if(([undefined, null].includes(entry["find_value_id"]) || entry.find_value_id.length <= 0) && !emptyValRows.includes(entry.label)){
                            emptyValRows.push(entry.label);
                        }
                    }else if(entry.action != 'Clear'){
                        eachRow["value_id"] = entry["value_id"]
                        if(([undefined, null].includes(entry["value_id"]) || entry.value_id.length <= 0) && !emptyValRows.includes(entry.label)){
                            emptyValRows.push(entry.label);
                        }
                    }
                }
                if(!emptyValRows.includes(entry.label)){
                    postData.push(eachRow);
                }
            }
            if(emptyValRows.length > 0){
                let mssg = `Value of the fields '${emptyValRows.join(",")}" are empty. \nDo you want to skip and proceed?`
                if(emptyValRows.length == 1){
                    mssg = `Value of the field '${emptyValRows.join(",")}" is empty. \nDo you want to skip and proceed?`
                }
                if(confirm(mssg)) {
                    return true
                }else{
                    return false;
                }
            }
            return true;
        },
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    },
    computed:{
        globalSettingsFromStartup:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
        filteredLoadTypes() {
            return this.loadTypes.filter(item =>
                !(this.disableFields || []).includes(item.field_id.toLowerCase())
            );
        }
    },
    created(){
        this.registerWebsocketNotifier();
        if(Object.keys(this.globalSettingsFromStartup).includes("CATALOG_READ_ONLY") && this.globalSettingsFromStartup.CATALOG_READ_ONLY){
            this.loadTypes = this.loadTypes.filter(e => e.row_type != 'CATALOG')
        }
        if(!('enable_multi_catalog_browse' in this.globalSettingsFromStartup) || ('enable_multi_catalog_browse' in this.globalSettingsFromStartup && this.globalSettingsFromStartup.enable_multi_catalog_browse)){
            this.catalogTypeReq.unshift("Append")
        }
        if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
            this.startupFieldsList = this.getStartUpDataFromInCache()["custom_metadatas"];
            if(this.startupFieldsList != undefined){
                let tempValList = [];
                for(let fDetails of this.startupFieldsList){
                    if(['PICKLIST','PICKLIST_MULTIVALUE'].includes(fDetails.type)){
                        for(let pickVal of fDetails.values){
                            tempValList.push({
                                "_id":pickVal.value_id,
                                "label":pickVal.value,
                                "field_id":fDetails._id
                            })
                        }
                    }
                    this.loadTypes.push({
                        "label":fDetails.name,
                        "row_type":fDetails.type,
                        "field_id":fDetails._id
                    })
                }
                this.pickListNameCollection = tempValList;
                this.findPickListNameCollection = tempValList;
            }
        }
        this.addSelectedLoadTypePath()
    },
    watch:{
        "$store.state.startUpData.startUpDataDetails.CATALOG_READ_ONLY":function(oldVal,newVal){
            if(newVal){
                this.loadTypes.splice(2,0,{label:"Catalog",row_type:"CATALOG"})
            }else{
                this.loadTypes = this.loadTypes.filter(e => e.row_type != 'CATALOG')    
            }
        }
    },
    beforeDestroy(){
        this.unRegisterWebsocketNotifier()
    }
}

</script>


<style scoped lang="scss">
    // $header-background: #1a1a1a;
    // $border-color: 1px solid #3a3a3a;
    // $background: #121212;
    // $background-color-on-hover: #141414;
    // $body-background-color: #141414;
    // $dull-text-color: #858585;
    // $options-text-color: #9c9c9c;
    // $icon-color-on-hover: #9c9c9c;
    // $text-color: #eee;
    // $table-row-border: none;
    // $table-border-color:1px solid #141414;
    // $active-blue: #007bff;
    // $danger-color: #dc3545 !important;
    // $input-field-bg-color: #1d1d1d;
    // $input-field-border-color: #303030;
    // $input-field-height:38px;
    // $button-height:38px;
    // $secondary-border-color: 1px solid #3a3a3a;
    // $searchBar-border-color: 1px solid #202020;
    // $secondary-text-color: #bbb;
    // $modal-border:1px solid #202020;
    // $modal-background: #121212;
    // $header-color:#9e9e9e;
    // $scrollbar-thumb-background:#333;
    // $scrollbar-track-background:#141414;
    // $scrollbar-thumb-on-hover-background:#555;
    // $input-field-padding:.375rem 10px;
    // $input-field-and-label-font-size:14px;
    // $danger-color: #dc3545 !important;
    // $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    // $active-green-color:#28a745;
    // $breadcrumb-background:#181818;
    // $mutliselect-tag-bg-color:#212121;
    // $multiselect-tag-border-color:#2e2e2e;
    // $mutliselect-all-tags-bg-color:#212121;
    // $multiselect-option-highlight-bg-color:#242424;
    // $multiselect-tag-on-focus-or-hover-bg-color:#121212;
    // $tags-font-size:12px;
    // $metadata-field-bg-color: #1d1d1d;
    // $metadata-border-color:#303030;
    // $metadata-border-color-on-hover: #5A5A5A;

    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #3a3a3a;
    textarea:focus{
        outline: none;
        bottom: 0px;
        inset-inline-start:0px;
        --saf-0: rgba(var(--sk_highlight,18,100,163),1);
        box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
        border-radius: 4px;
        border-color: transparent;
        -webkit-appearance: none;
    }
    .comm-input-field-style{
        background: $primary-background !important;
        float: inline-start;
        width:100%;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }
    .empty-field-text-styles{
    color:$none-text-color;
    }

    .input-field-wrapper{
        display: inline-flex;
        width: 100%;
        position: relative;
        svg{
        position: absolute;
        inset-inline-end: -27px;
        top: 12px;
        height:25px;
        }
    }

    .fields-on-non-edit-mode{
    width:100%;
    display:inline-flex;
    line-height:46px;
    }

    .bigger-checkboxes {
        height: 30px;
        width: 20px;
        position:relative;
    }
    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block !important;
        width: 22px !important;
        height: 21px !important;
        margin-top: 5px !important;
        margin-inline-start: -1px !important;
        border: $border-color !important;
        border-radius: 0.25em !important;
        background: $primary-background !important;
    }
    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue !important;
        position: absolute !important;
        font-size: 16px !important;
        line-height: 1 !important;
        transition: all 0.2s !important;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px !important;
        padding-top: 2px !important;
    }

    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .add-screens-styles{
        display: inline-flex;
        height: 40px;
        border: 1px solid $add-button-border-color;
        border-radius: 5px;
        width: 97%;
        margin: 6px 0px 8px 6px;
        justify-content: center;
        line-height: 36px;
        color:$add-button-text-color;
    }

    .add-screens-styles:hover{
        border: 1px solid $add-button-border-on-hover;
        color:$add-button-text-color-hover;
    }
    .tags-display-ul{
    list-style-type: none;
    }

    .tags-display-ul .show-tags-delete{
    visibility:hidden;
    }

    .searched-metadata-display-fields{
    height: auto;
    width: 90%;
    }

    .view-tags:hover .show-tags-delete{
    visibility: visible;
    }

    .view-tags:hover {
    border: $secondary-border-color !important;
    }

    .key-style {
    color: $dull-text-color;
    width: 30%;
    text-align: center;
    font-size: $input-field-and-label-font-size;
    padding-inline-start: 5px;
    padding-inline-end: 5px;
    margin-top: 13px;
    }

    .activeTag{
        color: $active-blue !important;
    }
    .view-tags{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border: $secondary-border-color !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: center;
        width:auto !important;
        padding-inline-start: 12px !important;
        justify-content: center;
        padding-top: 1px !important;
        div{
                padding: 0px 8px;
                margin-inline-start: 0px;
                font-size: 12px;
                border-radius: 15px !important;
                position: relative;
                top: 1px;
        }
    }

    .view-fields-styles{
        font-size: 12px;
        height: 24px;
        display: inline-flex;
        margin:2px !important;
        border-radius: 15px !important;
        min-width: 50px;
        padding: 0px !important;
        text-align: start;
        width:98% !important;
        padding-inline-start: 12px !important;
        justify-content: start;
        padding-top: 1px !important;
        div{
                padding: 0px 8px;
                margin-inline-start: 0px;
                font-size: 14px;
                line-height: 32px;
                color: #858585;
                text-align:end;
        }
    }

    .comm-tags-field-wrapper-style{
         background: $primary-background!important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        min-height: $input-field-height;
        margin-top:1px;
        margin-bottom:1px;
        border-radius: 4px;
    }

    ::v-deep{
    .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
    .mx-input{
        background-color: $primary-background  !important;
        border: none !important;
        color: $text-color !important;
    }
    .mx-datepicker-main{
        border: $border-color !important;
        background: $secondary-background-color !important;
    }
    .mx-calendar-content .cell:hover{
        background-color: $bg-color-on-hover !important;
    }
    .mx-datepicker-range{
        width:100%
    }
    .mx-calendar-content .cell:hover {
        color: #000000;
        background-color: #7d99b1;
    }
    .mx-icon-calendar{
        color:$text-color;
    }
    }

    .value-style{
    width: 98%;
    text-align: start;
    padding-top: 0px;
    padding-bottom: 3px;
    padding-inline-end: 5px;
    .slug-ellipsis{
        white-space: nowrap;
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    }
    .input-fields{
        border: none;
        border-radius: 0px !important;
        // margin-inline-start:5px;
        // margin-bottom: 7px;
    }

    .input-fields:focus{
        outline: unset;
        border-bottom: 1px solid #0373ee !important;
    }

    .focusField{
        input:focus, select:focus{
        border:none !important;
    }
    }

    .tags-wrapper{
    position: absolute;
    inset-inline-end: 0px;
    }

    svg {
    color: #666666;
    }

    svg:hover {
    color: $text-color;
    }

    .table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    width: 100%;
    thead {
            color: $dull-text-color !important;
            position: relative;
        th{
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index:9;
            text-align: start;
            padding:0px;
            border:none;
        }
    }
    tbody {
        width: 100%;
        overflow: auto;
        font-weight: 500;
        tr{
        height:40px;
        border-bottom: 1px solid $primary-background;
        padding:0px;
        }
    }
    }


    .delete-btn {
        visibility: hidden;
    }
    .comm-table-row:hover .delete-btn {
        visibility: visible;
        position: relative;
        inset-inline-start:18px;
        vertical-align: top;
    }

    /* width */
    ::-webkit-scrollbar {
    width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
    }

    .height-set-for-component {
    height: calc(100% - 120px);
    }

    ::v-deep{
    .multiselect{
            width:100% !important;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            padding: 4px 40px 0 8px;
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            width:28%;
            height: auto;
        }
        .multiselect__single{
            padding-top:3px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 240px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background:$secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background !important;
            height: auto;
        }
    }

    .browse-icon{
        position: relative;
        inset-inline-start:8px;
        top: 8px;
    }

    .table td, .table th {
        border-top: none;
        padding:0px;
    }

    .display-as-tags{
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: start;
        float: inline-start;
    }

    .select-catalog-field{
        width: 101%;
        .value-style{
        width:100%;
        }
    }

    .editIconClass{
    visibility: hidden;
    }

    .comm-screen-profile-fields:hover{
    .editIconClass{
        visibility: visible;
        margin-inline-start: 8px;
    }
    }

    .user-name-or-image-in-selected-option{
    border: $border-color;
    height: 27px;
    width: 27px;
    border-radius: 5px;
    text-align: center;
    line-height: 26px;
    text-transform: uppercase;
    margin-top: -1px;
    margin-inline-start: -1px;
    }

    .tags-style{
        display: inline-flex;
        margin-inline-end: 5px;
        margin-bottom: 5px;
        height: 27px;
        margin-inline-start: 3px;
        float:inline-start;
    .user-name-display-as-tags{
        line-height: 27px;
        margin: 0px 5px;
        width:auto;
    }
    }

    .comm-field-wrapper{
        padding:5px;
        vertical-align: top;
    }

    .select-action-styles{
        margin-inline-end:10px;
        position: relative;
        top: 5px;
        width: 35% !important;
    }

    .primary-btn-style{
        margin-top:1%;
        height:70px;
        display:inline-flex !important;
        flex-wrap: nowrap !important;
        margin-inline-start:4px;
        button{
            height: 37px !important;
            border-radius: 5px;
            width: 100px;
            font-size:14px;
        }
    }
    .action-select-dropdown{
        width: 36% !important;
        margin-inline-end: 9px;
    }

</style>